module.exports = __webpack_public_path__ + "static/media/nazka-team-2.72076094.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/nazka-team-2.jpg
// module id = 292
// module chunks = 0